import React from "react";
import StoneHeartInterstitial from "../stone-heart-interstitial";
import Footer from "../global/footer";

const StoneHeartLanding = ({ footer }) => {
  const { menuv3 } = footer;
  return (
    <>
      <StoneHeartInterstitial />
      <Footer isBg="yes" menu={menuv3} />
    </>
  );
};

export default StoneHeartLanding;
